/* eslint-disable no-underscore-dangle */
import { cmpLog, LOG_TYPE_EXTENDED, LOG_TYPE_ERROR, REJECTED_BY_PURPOSES, NO_VENDOR_FOUND, FAILED, SUCCESS, CROSS_CHECK_VENDOR, CROSS_CHECK_VENDOR_FAILED } from './logger';

var getVendor = function getVendor(id) {
  return window.consents.vendorsList[id];
};

export var getRealConsent = function getRealConsent(id) {
  return window.consents.filteredVendors.includes(id);
};
export var getConsent = function getConsent(id) {
  var vendor = window.consents.vendorsList[id] && window.consents.vendorsList[id].name;

  if (vendor) {
    var vendorConsent = window.consents.vendors.includes(id);
    var crossedConsent = getRealConsent(id);
    return {
      vendor: vendor,
      consent: crossedConsent,
      restrictions: vendorConsent && !crossedConsent ? "".concat(vendor.toUpperCase(), " ").concat(REJECTED_BY_PURPOSES) : null
    };
  }

  return "".concat(NO_VENDOR_FOUND, " ").concat(id);
};

var searchVendor = function searchVendor(string) {
  var vendors = Object.values(window.consents.vendorsList).filter(function (vendor) {
    return vendor.name.toLowerCase().includes(string.toLowerCase());
  });
  return vendors;
}; // Returns consent crossing the consent information from the Vendor and Purposes
// Consent is considered rejected for a vendor if ANY of its declared purposes is not accepted


export var checkVendorPurposes = function checkVendorPurposes(id) {
  return new Promise(function (resolve, reject) {
    if (Object.keys(window.consents.vendorsList).length > 0 && getVendor(id)) {
      window.__tcfapi('getVendorConsent', 2, function (vendorConsent, success) {
        cmpLog(LOG_TYPE_EXTENDED, "".concat(CROSS_CHECK_VENDOR, " [").concat(id, "]"), getVendor(id).name, success ? SUCCESS : FAILED, vendorConsent);

        if (success) {
          resolve(vendorConsent);
        } else {
          cmpLog(LOG_TYPE_ERROR, "".concat(CROSS_CHECK_VENDOR_FAILED, " ").concat(id));
          reject();
        }
      }, id);
    }

    reject();
  });
};
export var saveConsentValue = function saveConsentValue(vendorName, vendorValue) {
  localStorage.setItem(vendorName, vendorValue);
};
export var CONSENTS_INTERFACE = {
  chartbeat: false,
  vendors: null,
  filteredVendors: null,
  purposes: null,
  tcString: null,
  googleIds: null,
  comscore: false,
  google: {
    advertising: false,
    associatedTechnologies: false,
    associatedIds: null
  },
  dmp: false,
  vendorsList: {},
  purposesList: {},
  getVendor: getVendor,
  getConsent: getConsent,
  searchVendor: searchVendor,
  checkVendorPurposes: checkVendorPurposes,
  saveConsentValue: saveConsentValue
};